import {Directive, ElementRef, Input, OnChanges} from '@angular/core';
import {PatientRecord} from "../../../../app.services/clinical/patient.record/models/patient.record";
import {ModalityTypeGroupService} from "./modality.type.group.service";
import {IThemeColor} from 'common/ui/components/button';
import {Themes, ThemeService} from 'common/ui/services/theme.changer';
import {Observable} from 'rxjs-compat';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {RtlService} from "../../../rtl/services/rtl.service";

@UntilDestroy()
@Directive({
	selector: '[cpBorderStatusIndication]',
})
export class BorderStatusIndicationDirective implements OnChanges{
	@Input() patientRecord : PatientRecord;
    @Input() disableIndication:boolean=false;
	@Input() modalityTypeGroupKey: number = -1;

	constructor(private elementRef: ElementRef,
				private modaltyTypeGrpSvc:ModalityTypeGroupService,
				private themeSvc:ThemeService,
				private rtlService: RtlService) {
	}

	ngOnChanges() {
		if(this.modalityTypeGroupKey<0){
		if (!this.disableIndication){
			let leftBorderColor = this.getBorderColor(this.patientRecord.worklistRowRaw["MODALITY_TYPE_GROUP_KEY"]);
			leftBorderColor.pipe(untilDestroyed(this)).subscribe(color=>{
				let side = this.rtlService.isRtl() ? 'right' : 'left';
				let css = `
                border-${side}-color: ${color};`;
				this.elementRef.nativeElement.setAttribute("style", css);
			})
		}
	} else{
		this.getBorderColor(this.modalityTypeGroupKey);
		}
	}

    private getBorderColor(modalityTypeKey:number){
		switch (this.themeSvc.currentTheme) {
			case Themes.dark:
				return this.getColorForModalityType(modalityTypeKey).map(x=>x.dark);
			case Themes.light:
				return this.getColorForModalityType(modalityTypeKey).map(x=>x.light);
		}
	}
	private getColorForModalityType(modalityTypeKey:number):Observable<IThemeColor>{
		return this.modaltyTypeGrpSvc.getModalityTypeGroupColorByKey(modalityTypeKey);
	}
}
